import { ReactElement } from 'react';
import styles from './merge-account-notification.module.scss';
import DashboardMemberTransferEmailView from '@utmb/types/view/DashboardMemberTransferEmailView';
import { Font } from '@utmb/design-system/text/font';
import { getColorStyle } from '@utmb/utils/colors';
import { ColorTypesEnum } from '@utmb/types/colors';
import { Icon } from '@utmb/design-system/icons/Icon';
import { IconsEnum } from '@utmb/types/icons';
import { UserMemberTransferStatusEnum } from '@utmb/types/enum/UserMemberTransferStatusEnum';
import { useTranslation } from 'next-i18next';

export interface MergeAccountNotification {
    transfer: DashboardMemberTransferEmailView | undefined;
    callback: () => void;
}

export const MergeAccountNotification = ({ transfer, callback }: MergeAccountNotification): ReactElement | null => {
    const { t } = useTranslation();
    return transfer?.state === UserMemberTransferStatusEnum.REQUESTED ? (
        <button className={styles.mergeAccountNotification} onClick={callback}>
            <div className={styles.container}>
                <Icon clss={styles.svg} variant={IconsEnum.HELP} color={getColorStyle(ColorTypesEnum.WHITE)} />
                <Font.FuturaHeavy as="span" desktop="16" mobile="14" color={getColorStyle(ColorTypesEnum.WHITE)}>
                    {t('myUtmb.email.notification.label') + ' '}
                    <Font.FuturaHeavy className={styles.textLink} as="span">
                        {t('myUtmb.email.notification.click')}
                    </Font.FuturaHeavy>
                </Font.FuturaHeavy>
                <br />
            </div>
        </button>
    ) : null;
};
